import { useProspectsRequest } from "../../apis/prospects/useProspectsRequest";

export const useProspectsHandlers = () => {
  const {
    getProspects,
    getProspectsTrialLimit,
    autocompleteCompanies,
    autocompleteJobTitles,
    autocompleteIndustries,
    autocompleteLocations,
  } = useProspectsRequest();

  const getProspectsHandler = async (params: any) => {
    let queryString = "";
    if (params && typeof params === "object") {
      queryString = Object.entries(params)
        .filter(([_, value]) => {
          if (Array.isArray(value)) return value.length > 0;
          return value !== undefined && value !== null && value !== "";
        })
        .flatMap(([key, value]) => {
          if (Array.isArray(value)) {
            return value.map((v: string) => `${encodeURIComponent(key)}=${encodeURIComponent(v)}`);
          }
          return [`${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`];
        })
        .join("&");
    }
    return await getProspects(queryString);
  };

  const getProspectsTrialLimitHandler = async () => {
    return await getProspectsTrialLimit();
  };

  const autocompleteCompaniesHandler = async (params: any) => {
    console.log(params);
    return await autocompleteCompanies(params);
  };

  const autocompleteJobTitlesHandler = async (params: any) => {
    return await autocompleteJobTitles(params);
  };

  const autocompleteIndustriesHandler = async (params: any) => {
    return await autocompleteIndustries(params);
  };

  const autocompleteLocationsHandler = async (params: any) => {
    return await autocompleteLocations(params);
  };

  return {
    getProspectsHandler,
    getProspectsTrialLimitHandler,
    autocompleteCompaniesHandler,
    autocompleteJobTitlesHandler,
    autocompleteIndustriesHandler,
    autocompleteLocationsHandler,
  };
};
